module.exports = __webpack_public_path__ + "img/NextCloud.3b7639c.svg";